import React, { FC, useCallback, useState } from "react";
import i18next, { changeLanguage } from "i18next";

import LanguageSwitcher from "./LanguageSwitcher";

import { PLATFORM_LANGUAGES, PlatformLanguage } from "@constants";

const LanguageSwitcherContainer: FC = () => {
  const [open, setOpen] = useState(false);

  const handleToggle = (): void => {
    setOpen(!open);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLanguageChanged = async (lng: PlatformLanguage): Promise<void> => {
    await changeLanguage(lng.code);
  };

  const findLanguageName = useCallback(
    (code: string) =>
      PLATFORM_LANGUAGES.find((lng) => lng.code === code)?.name || code,
    [],
  );

  return (
    <LanguageSwitcher
      open={open}
      onClose={handleClose}
      onToggle={handleToggle}
      handleLanguageChanged={handleLanguageChanged}
      findLanguageName={findLanguageName}
      currentLanguage={i18next.resolvedLanguage || "en"}
    />
  );
};

export default LanguageSwitcherContainer;
